export default {
  appName: "Kazigraphix",
  domain: process.env.NODE_ENV === 'production' ? "https://www.kazigraphix.com" : "http://127.0.0.1:8000",
  shortDesc: "Top-rated branding agency",
  localUserKey: "kazigraphix_utk",
}
